// checkLength to limit characters where maxLength does not work
var textAreaMaxLength = 144;
function checkLength(ta) {
    if (ta.value.length > textAreaMaxLength) {
        ta.value = ta.value.substring(0, textAreaMaxLength);
    }
}
//Character countdown for textarea
$('#nameFavoriteOrder').on('click keyup change', function () {
    var instructionValue = $(this).val();
    var maxLength = parseInt($(this).attr('maxlength') || 144);
    if (instructionValue.length > maxLength) {
        instructionValue = instructionValue.substring(0, maxLength);
        $(this).val(instructionValue);
    }
    $('.characters-left').text(maxLength - instructionValue.length);

    if ($(this).val().trim() == "") {
        $('#saveAddFavorite').addClass('disabled')
    } else {
        $('#saveAddFavorite').removeClass('disabled')
    }
});
//drivertip click functionality	

function calculateDriverTip(x, drivertip) {
    var total = 70;
    var tip;
    if (x == "noother") {
        drivertip = drivertip.slice(0, 2);
        void 0;
        tip = (drivertip / 100) * total;
        void 0;
    } else {
        void 0;
        tip = (drivertip / 100) * total;
        void 0;
    }
}

$('#errorDiv').hide();
$('.Rectangle-2').click(function (event) {
    var status = $(this).attr('id');
    var divValue = $(this).text();
    var tipentered = $("#entertip").val();
    void 0;
    void 0;
    if (status == "div10") {
        $('#div10').addClass("cssclass");
        $('#div15').removeClass("cssclass");
        $('#div20').removeClass("cssclass");
        $('#div25').removeClass("cssclass");
        $('#divother').removeClass("cssclass");
        $("#entertip").val(null);
        $("#entertip").attr("readonly", true);
        $('#errorDiv').hide();
    } else if (status == "div20") {
        $('#div20').addClass("cssclass");
        $('#div10').removeClass("cssclass");
        $('#div15').removeClass("cssclass");
        $('#div25').removeClass("cssclass");
        $('#divother').removeClass("cssclass");
        $("#entertip").val(null);
        $("#entertip").attr("readonly", true);
        $('#errorDiv').hide();
    } else if (status == "div25") {
        $('#div25').addClass("cssclass");
        $('#div10').removeClass("cssclass");
        $('#div15').removeClass("cssclass");
        $('#div20').removeClass("cssclass");
        $('#divother').removeClass("cssclass");
        $("#entertip").val(null);
        $("#entertip").attr("readonly", true);
        $('#errorDiv').hide();
    } else if (status == "divother") {
        $('#divother').addClass("cssclass");
        $('#div10').removeClass("cssclass");
        $('#div15').removeClass("cssclass");
        $('#div20').removeClass("cssclass");
        $('#div25').removeClass("cssclass");
        $("#entertip").attr("readonly", false);
        if ($("#entertip").val() == '') {
            $('#errorDiv').show();
        } else {
            $('#errorDiv').hide();
            calculateDriverTip('other', tipentered);
        }
    } else {
        $('#div15').addClass("cssclass");
        $('#div10').removeClass("cssclass");
        $('#div20').removeClass("cssclass");
        $('#div25').removeClass("cssclass");
        $('#divother').removeClass("cssclass");
        $("#entertip").val(null);
        $("#entertip").attr("readonly", true);
        $('#errorDiv').hide();
    }
    if (status !== "divother") {
        calculateDriverTip('noother', divValue)
    }
});
$("#entertip").on("keydown, keyup", function () {
    if ($("#entertip").val() === '') {
        $('#errorDiv').show();
    } else {
        $('#errorDiv').hide();
    }
});
    //end of driver tip
